import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Code"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M23.25 12L18 17.25L16.9425 16.1925L21.1275 12L16.9425 7.8075L18 6.75L23.25 12ZM0.75 12L6 6.75L7.0575 7.8075L2.8725 12L7.0575 16.1925L6 17.25L0.75 12ZM9.31502 19.113L13.23 4.5L14.679 4.88775L10.764 19.5L9.31502 19.113Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Code.vue"]]);
